import { createAction, props } from '@ngrx/store';
import { TermPayment } from './report.model';

// Term Payment Report
export const fetchTermPaymentRecords = createAction(
    '[Data] fetch term payments records'
);

export const fetchTermPaymentRecordsSuccess = createAction(
    '[Data] fetch term payments records success', 
    props<{ termPaymentData: TermPayment[], termPaymentsTotal: number }>()
);

export const fetchTermPaymentRecordsFail = createAction(
    '[Data] fetch term payments records failure', 
    props<{ termPaymentError: string }>()
);

// Collect Master Report
export const collectMasterReportRecords = createAction(
    '[Data] fetch collect master report records'
);

export const collectMasterReportRecordsSuccess = createAction(
    '[Data] fetch collect master report records success', 
    props<{ collectMasterReportData: TermPayment[], collectMasterReportTotal: number }>()
);

export const collectMasterReportRecordsFail = createAction(
    '[Data] fetch collect master report records failure', 
    props<{ collectMasterReportError: string }>()
);


// Call List Report
export const callListReportRecords = createAction(
    '[Data] fetch call list report records'
);

export const callListReportRecordsSuccess = createAction(
    '[Data] fetch call list report records success', 
    props<{ callListReportData: TermPayment[], callListReportTotal: number }>()
);

export const callListReportRecordsFail = createAction(
    '[Data] fetch call list report records failure', 
    props<{ callListReportError: string }>()
);


// Duplicate Dossier Report
export const duplicateDossierReportRecords = createAction(
    '[Data] fetch duplicate dossier report records'
);

export const duplicateDossierReportRecordsSuccess = createAction(
    '[Data] fetch duplicate dossier report records success', 
    props<{ duplicateDossierReportData: TermPayment[], duplicateDossierReportTotal: number }>()
);

export const duplicateDossierReportRecordsFail = createAction(
    '[Data] fetch duplicate dossier report records failure', 
    props<{ duplicateDossierReportError: string }>()
);

// Duplicate Member Report
export const duplicateMemberReportRecords = createAction(
    '[Data] fetch duplicate member report records'
);

export const duplicateMemberReportRecordsSuccess = createAction(
    '[Data] fetch duplicate member report records success', 
    props<{ duplicateMemberReportData: TermPayment[], duplicateMemberReportTotal: number }>()
);

export const duplicateMemberReportRecordsFail = createAction(
    '[Data] fetch duplicate member report records failure', 
    props<{ duplicateMemberReportError: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state report',
);